/**
 * Funnel events for the upgrade-plan promo (CL-6252).
 *
 * Naming follows the existing `dashboard_*` event prefix convention used
 * across `features/dashboard/lib/constants.ts` and `features/billing/lib/
 * constants.ts`.
 */
export enum UpgradePromoEvent {
  ELIGIBILITY_EVALUATED = 'dashboard_upgrade_promo_eligibility_evaluated',
  SHOWN = 'dashboard_upgrade_promo_shown',
  CTA_CLICK = 'dashboard_upgrade_promo_cta_click',
  DISMISSED = 'dashboard_upgrade_promo_dismissed',
  DEMOTED_TO_BANNER = 'dashboard_upgrade_promo_demoted_to_banner',
  VIEW_ALL_PLANS = 'dashboard_upgrade_promo_view_all_plans',
}

/**
 * Re-prompt cadence for individual / PAYGO accounts. Matches the CL-6252
 * spec: first prompt after dismissal at +15 days, then every 30 days.
 */
export const INDIVIDUAL_REPROMPT_DAYS = [15, 30] as const;

/**
 * Self-serve trigger threshold — fires when the user has consumed at least
 * this percentage of the current cycle's granted credits.
 */
export const SELF_SERVE_USAGE_THRESHOLD_PCT = 80;

/**
 * Cooldown applied to self-serve users after any dismissal (X / Maybe later
 * / CTA / View all plans). Shorter than the individual cadence because the
 * usage signal is more urgent — they're spending credits. Snoozes the
 * promo for a week before re-prompting.
 */
export const SELF_SERVE_REPROMPT_DAYS = 7;
